import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill out this field' }
      ]
    },
   lastName: {
      validations: [
        { type: 'required', message: 'Please fill out this field' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill out this field' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please fill out this field' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    cellNumber: {
      validations: [
        { type: 'required', message: 'Please fill out this field' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    starttime: {
      validations: [
        { type: 'required', message: 'Please fill out this field' }
      ]
    }, 
    endtime: {
      validations: [
        { type: 'required', message: 'Please fill out this field' }
      ]
    }, 
    category: {
      validations: [
        { type: 'required', message: 'Please fill out this field' }
      ]
    },
    sitename: {
      validations: [
        { type: 'required', message: 'Please fill out this field' }
      ]
    },
    siteaddress: {
      validations: [
        { type: 'required', message: 'Please fill out this field' }
      ]
    },
    sitecity: {
      validations: [
        { type: 'required', message: 'Please fill out this field' }
      ]
    },
    sitestate: {
      validations: [
        { type: 'required', message: 'Please fill out this field' }
      ]
    },
    sitepostal: {
      validations: [
        { type: 'required', message: 'Please fill out this field' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please fill out this field' },
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please fill out this field' }
      ]
    },
    eventextra5: {
      validations: [
        { type: 'required', message: 'Please fill out this field' }
      ]
    },   
    subeventcomments: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name',
            mapping: 'firstName',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name',
            mapping: 'lastName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Work Phone',
            mapping: 'telNumber',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Cell Phone',
            mapping: 'cellNumber',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address',
            mapping: 'email',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Location',
            mapping: 'sitename',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address Line',
            mapping: 'siteaddress',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City',
            mapping: 'sitecity',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'State',
            mapping: 'sitestate',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Postal',
            mapping: 'sitepostal',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date',
            mapping: 'eventDate',
            customClasses: ['no-label']
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Start Time',
            options: [
              { label: '6:00AM', value: '06:00:00' },
              { label: '6:30AM', value: '06:30:00' },
              { label: '7:00AM', value: '07:00:00' },
              { label: '7:30AM', value: '07:30:00' },
              { label: '8:00AM', value: '08:00:00' },
              { label: '8:30AM', value: '08:30:00' },
              { label: '9:00AM', value: '09:00:00' },
              { label: '9:30AM', value: '09:30:00' },
              { label: '10:00AM', value: '10:00:00' },
              { label: '10:30AM', value: '10:30:00' },
              { label: '11:00AM', value: '11:00:00' },
              { label: '11:30AM', value: '11:30:00' },
              { label: '12:00PM', value: '12:00:00' },
              { label: '12:30PM', value: '12:30:00' },
              { label: '1:00PM', value: '13:00:00' },
              { label: '1:30PM', value: '13:30:00' },
              { label: '2:00PM', value: '14:00:00' },
              { label: '2:30PM', value: '14:30:00' },
              { label: '3:00PM', value: '15:00:00' },
              { label: '3:30PM', value: '15:30:00' },
              { label: '4:00PM', value: '16:00:00' },
              { label: '4:30PM', value: '16:30:00' },
              { label: '5:00PM', value: '17:00:00' },
              { label: '5:30PM', value: '17:30:00' },
              { label: '6:00PM', value: '18:00:00' },
              { label: '6:30PM', value: '18:30:00' },
              { label: '7:00PM', value: '19:00:00' },
              { label: '7:30PM', value: '19:30:00' },
              { label: '8:00PM', value: '20:00:00' },
              { label: '8:30PM', value: '20:30:00' },
              { label: '9:00PM', value: '21:00:00' },
              { label: '9:30PM', value: '21:30:00' },
              { label: '10:00PM', value: '22:00:00' }
            ],
            mapping: 'starttime',
            customClasses: ['no-label']
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'End Time',
            options: [
              { label: '6:00AM', value: '06:00:00' },
              { label: '6:30AM', value: '06:30:00' },
              { label: '7:00AM', value: '07:00:00' },
              { label: '7:30AM', value: '07:30:00' },
              { label: '8:00AM', value: '08:00:00' },
              { label: '8:30AM', value: '08:30:00' },
              { label: '9:00AM', value: '09:00:00' },
              { label: '9:30AM', value: '09:30:00' },
              { label: '10:00AM', value: '10:00:00' },
              { label: '10:30AM', value: '10:30:00' },
              { label: '11:00AM', value: '11:00:00' },
              { label: '11:30AM', value: '11:30:00' },
              { label: '12:00PM', value: '12:00:00' },
              { label: '12:30PM', value: '12:30:00' },
              { label: '1:00PM', value: '13:00:00' },
              { label: '1:30PM', value: '13:30:00' },
              { label: '2:00PM', value: '14:00:00' },
              { label: '2:30PM', value: '14:30:00' },
              { label: '3:00PM', value: '15:00:00' },
              { label: '3:30PM', value: '15:30:00' },
              { label: '4:00PM', value: '16:00:00' },
              { label: '4:30PM', value: '16:30:00' },
              { label: '5:00PM', value: '17:00:00' },
              { label: '5:30PM', value: '17:30:00' },
              { label: '6:00PM', value: '18:00:00' },
              { label: '6:30PM', value: '18:30:00' },
              { label: '7:00PM', value: '19:00:00' },
              { label: '7:30PM', value: '19:30:00' },
              { label: '8:00PM', value: '20:00:00' },
              { label: '8:30PM', value: '20:30:00' },
              { label: '9:00PM', value: '21:00:00' },
              { label: '9:30PM', value: '21:30:00' },
              { label: '10:00PM', value: '22:00:00' }
            ],
            mapping: 'endtime',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type',
            options: [
              { label: 'Bag Lunch' , value: 'Bag Lunch'},
              { label: 'Buffet', value: 'Buffet'},
              { label: 'Family Style', value: 'Family Style'},
              { label: 'Plated', value: 'Plated' }
            ],
            mapping: 'category',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests',
            mapping: 'plannedguestcount',
            customClasses: ['no-label']
          }
        ]
      },   
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Budget',
            mapping: 'eventextra5',
            customClasses: ['no-label']
          }
        ]
      },   
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Event Description',
            mapping: 'subeventcomments',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'The Sioux Chef Contact Form',
    formId: '340',
    clientKey: '4F5CB307-DEF6-48E9-BEFB-C83D0A8038EF',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/thesiouxchef/form_structure.js